import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(private translateService: TranslateService) {}

  setDefaultLang(lang: string): void {
    this.translateService.setDefaultLang(lang);
  }

  use(lang: string): Observable<any> {
    return this.translateService.use(lang);
  }
}
